<template>
  <div class="signup-flow-wrapper">
    <SignupSuccessCard
        v-if="isRequestSent"
        @back="handleBackToLogin"
    />

    <SignupFormCard
        v-else
        :loading="loading"
        @submit="handleSubmit"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useAuthStore } from '@/store/auth-store'
import { storeToRefs } from 'pinia'
import { useRouter } from 'vue-router'
import { Routes } from '@/config/router/routes'
import SignupFormCard from './components/SignupFormCard.vue'
import SignupSuccessCard from './components/SignupSuccessCard.vue'
import type { SignUpPayload } from '@/api/modules/auth/types'

const router = useRouter()
const authStore = useAuthStore()
const { loading } = storeToRefs(authStore)

const isRequestSent = ref<boolean>(false)

const handleSubmit = async (formData: SignUpPayload) => {
  try {
    await authStore.signUpNew(formData)
    isRequestSent.value = true
  } catch (error) {
    console.error('Registration error:', error)
  }
}

const handleBackToLogin = () => {
  router.push(Routes.Login)
}
</script>

<style lang="scss" scoped>
.signup-flow-wrapper {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}
</style>